import React from "react";
import PropTypes from "prop-types";
import Spinner from "react-webpack-spinner";
import { FaFilePdf } from "react-icons/fa";

import SelectInput from "../SelectInput";

class FilterBox extends React.Component {
  setActiveInstitution = key => {
    this.props.onSetActiveInstitution(key);
  };

  setFilters = filters => {
    const { districts, categories, freetext, offborders } = filters;
    this.props.onSetFilters({
      districts: districts || this.props.districtsFilter,
      categories: categories || this.props.categoriesFilter,
      freetext: freetext === undefined ? this.props.freetextFilter : freetext,
      offborders:
        offborders === undefined ? this.props.offbordersFilter : offborders
    });
  };

  handleSelectChangeDistricts = districts => this.setFilters({ districts });
  handleSelectChangeCategories = categories => this.setFilters({ categories });
  handleChangeFreetext = freetext => this.setFilters({ freetext });
  handleChangeOffbordersFilter = () =>
    this.setFilters({ offborders: !this.props.offbordersFilter });

  render() {
    const {
      institutions,
      activeInstitution,
      categories,
      districts,
      districtsFilter,
      categoriesFilter,
      freetextFilter,
      offbordersFilter,
      pdfLink,
      isLoadingCategories,
      isFetchingInstitutions,
      className
    } = this.props;

    return (
      <div className={`flex-column filterbox ${className}`}>
        <div className="flex-0-0 box">
          <h2 className="subtitle small is-hidden-mobile">
            Stadtteile / Bezirke
          </h2>
          <SelectInput
            placeholder="Stadtteile auswählen"
            groupFormatter={option => `Bezirk ${option}`}
            options={districts}
            selectedOptions={districtsFilter}
            onChange={this.handleSelectChangeDistricts}
          />
        </div>

        <div className="flex-0-0 box">
          <h2 className="subtitle small is-hidden-mobile">
            Kategorien{" "}
            {isLoadingCategories && (
              <Spinner width={24} height={24} color="#000" />
            )}
          </h2>
          {!isLoadingCategories && (
            <SelectInput
              placeholder="Kategorien auswählen"
              options={categories}
              selectedOptions={categoriesFilter}
              onChange={this.handleSelectChangeCategories}
            />
          )}
        </div>

        <div className="flex-0-0 is-full box">
          <h2 className="subtitle small is-hidden-mobile">Freitext</h2>
          <input
            className="input"
            onChange={event => this.handleChangeFreetext(event.target.value)}
            placeholder="Einrichtungsname / Ansprechpartner / Schlagwort"
            value={freetextFilter}
          />
          <label className="checkbox">
            <input
              checked={offbordersFilter}
              type="checkbox"
              style={{ margin: 8, marginLeft: 0 }}
              onChange={this.handleChangeOffbordersFilter}
            />
            Stadtteil- / bezirksübergreifende Angebote zeigen
          </label>
        </div>

        {institutions.length || isFetchingInstitutions ? (
          <div className="flex-1-1 flex-column box is-hidden-mobile overflow-scroll">
            {Boolean(institutions.length) && (
              <h2 className="flex-0-0 subtitle">
                <a className="pdf-icon" href={pdfLink}>
                  <FaFilePdf />
                </a>
                {institutions.length}{" "}
                {institutions.length === 1 ? "Suchergebnis" : "Suchergebnisse"}
              </h2>
            )}
            {institutions.length ? (
              <ul className="flex-1-1 menu-list overflow-scroll">
                {institutions.map(item => {
                  return (
                    <li
                      key={item._key}
                      className={`${!item.approved ? "unapproved" : ""}`}
                    >
                      <a
                        onClick={() => this.setActiveInstitution(item._key)}
                        className={`${
                          activeInstitution === item._key ? "is-active" : null
                        }`}
                      >
                        {item.name}
                      </a>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="flex-0-0 has-text-centered">
                <Spinner width={48} height={48} color="#000" />
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

FilterBox.propTypes = {
  institutions: PropTypes.array,
  activeInstitution: PropTypes.string,
  onSetFilters: PropTypes.func,
  categories: PropTypes.array,
  districts: PropTypes.array,
  isLoadingCategories: PropTypes.bool,
  isFetchingInstitutions: PropTypes.bool
};

export default FilterBox;



/** WEBPACK FOOTER **
 ** ./src/components/FilterBox/FilterBox.jsx
 **/